import { CalendarEventType, ICalendarEvent } from 'src/generated-types/calendarEvent'

// Central reference for the calendar event-type values (kept in sync with the CalendarEventType
// union from the API) so call sites compare against named members instead of string literals.
export const CalendarEventTypes = {
  Deviation: 'Deviation',
  Service: 'Service',
  WorkOrder: 'WorkOrder',
  Document: 'Document',
} as const

export const ALL_TYPES: CalendarEventType[] = [
  CalendarEventTypes.Deviation,
  CalendarEventTypes.Service,
  CalendarEventTypes.WorkOrder,
  CalendarEventTypes.Document,
]

export const typeLabelKey: Record<CalendarEventType, string> = {
  [CalendarEventTypes.Deviation]: 'deviations',
  [CalendarEventTypes.Service]: 'services',
  [CalendarEventTypes.WorkOrder]: 'work-orders',
  [CalendarEventTypes.Document]: 'documents',
}

export interface CalendarPopoverState {
  event: ICalendarEvent
  position: { top: number; left: number }
}
